





























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bc-pos-cash-movements',
  components: {},
})
export default class PosCashMovements extends Vue {
  openCashMovementModal(type: string) {
    this.$emit('open-cash-movement-modal', type);
  }
}
